import lightBackgroundImage from "../assets/image/dc4-background.jpg";
import darkBackgroundImage from "../assets/image/dc4-background.jpg";
import loginBackgroundImage from '../assets/image/dc4-background.jpg';

const LIGHT_PRIMARY_COLOR = '#2374A5';
const DARK_PRIMARY_COLOR = '#0B2332';

export const lightAppColors = {
  backgroundImage: lightBackgroundImage,
  loginBackgroundImage: loginBackgroundImage,
  headerBackground: '#F8F8F8',
  headerText: '#000000',
  footerBackground: '#F8F8F8',
  footerText: '#707070',
  primaryText: '#FFFFFF',
  formBackground: '#FFFFFF',
  labelText: '#2C4960',
  inputBorder: '#2C4960',
  buttonBackground : '#2C4960',
  componentHeaderBackground : '#2C4960',
  buttonText: '#FFFFFF',
  buttonHover: '#1d5e87',
  primaryText: '#000000',
  titleText: '#FFFFFF',
  cardBackground: '#f2f2f2',
  border: '#ccc',
  darkBlue: '#195174',
  lightBlue: 'rgba(17, 78, 117, 0.1)',
  successBannerBackground: '#3FA34D',
  successBannerBorder: '#2C7A36',
  successBannerText: '#FFFFFF',
  myokBlue: '#2374A5',
};

export const darkAppColors = {
  // backgroundImage: lightBackgroundImage,
  // loginBackgroundImage: loginBackgroundImage,
  // headerBackground: '#F8F8F8',
  // headerText: '#000000',
  // footerBackground: '#F8F8F8',
  // footerText: '#707070',
  backgroundImage: lightBackgroundImage,
  loginBackgroundImage: loginBackgroundImage,
  headerBackground: '#F8F8F8',
  headerText: '#000000',
  footerBackground: '#F8F8F8',
  footerText: '#707070',
  primaryText: '#FFFFFF',
  formBackground: '#FFFFFF',
  labelText: '#2C4960',
  inputBorder: '#2C4960',
  buttonBackground : '#2C4960',
  componentHeaderBackground : '#2C4960',
  buttonText: '#FFFFFF',
  buttonHover: '#1d5e87',
  primaryText: '#000000',
  titleText: '#FFFFFF',
  cardBackground: '#f2f2f2',
  border: '#ccc',
  darkBlue: '#195174',
  lightBlue: 'rgba(17, 78, 117, 0.1)',
  successBannerBackground: '#3FA34D',
  successBannerBorder: '#2C7A36',
  successBannerText: '#FFFFFF',
  myokBlue: '#2374A5',
};

export const LightNavigationTheme = {
  dark: false,
  colors: {
    primary: LIGHT_PRIMARY_COLOR,
    background: 'transparent',
    card: LIGHT_PRIMARY_COLOR,
    border: 'green',
    text: 'white',
  },
};

export const DarkNavigationTheme = {
  dark: false,
  colors: {
    primary: DARK_PRIMARY_COLOR,
    background: 'transparent',
    card: DARK_PRIMARY_COLOR,
    border: 'green',
    text: 'white',
  },
};

export const LightAppTheme = {
  roundness: 2,
  colors: {
    ...lightAppColors,
    accent: 'black',
  },
};

export const DarkAppTheme = {
  roundness: 2,
  colors: {
    ...darkAppColors,
    accent: 'black',
  },
};
